import { cn } from "@/src/utils/shadcn";
import Image from "next/image";
export interface AwardCardModelProps {
  img: string;
}

export function AwardCardModel({ img }: AwardCardModelProps) {
  return (
    <div
      className={cn([
        // General
        "group/service bg-white text-accent-900 border dark:text-white  dark:shadow-none",

        // Layout
        "relative z-1 block h-full overflow-hidden rounded-5 p-6 m-8 md:p-4",

        // Fixed height for the card
        "h-[100px] md:h-[120px]",

        //Hover
        "hover:border-primary hover:bg-[rgba(82,128,193,.1)]",
      ])}
    >
      <div className="flex justify-center items-center h-auto">
        <img
          src={img}
          alt="iso"
          style={{width: '50%', height: 'auto' }}
          className="max-w-full max-h-full object-contain h-auto"
        />
      </div>
    </div>
  );
}
